import { useTheme } from "../lib/theme";

export function ThemeToggle({ className = "" }: { className?: string }) {
  const { theme, toggleTheme } = useTheme();
  const dark = theme === "dark";
  return <button
    className={`theme-toggle ${className}`.trim()}
    type="button"
    onClick={toggleTheme}
    aria-label={dark ? "Use light mode" : "Use dark mode"}
    title={dark ? "Use light mode" : "Use dark mode"}
    aria-pressed={dark}
  >
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      {dark
        ? <><circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.93 4.93l1.42 1.42M17.65 17.65l1.42 1.42M2 12h2M20 12h2M4.93 19.07l1.42-1.42M17.65 6.35l1.42-1.42"/></>
        : <path d="M20.5 14.3A8.5 8.5 0 0 1 9.7 3.5 8.5 8.5 0 1 0 20.5 14.3Z"/>}
    </svg>
    <span>{dark ? "Light mode" : "Dark mode"}</span>
  </button>;
}
